import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-227" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-228" data-mp="j7yex2vfcf1u">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-229" data-mp="j53uvcgbow8y">
          Todo lo que incluye:
        </h2>
        <p className="mt-3 text-center text-slate-300" data-id="element-230" data-mp="1bvktf666x43h">
          {productShortName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-white" data-id="element-231" data-mp="16vgcxg5a89d9">{price}</b>
        </p>

        <ul className="mt-10 grid gap-x-8 rounded-xl border border-slate-300/25 bg-blue-950 p-6 sm:grid-cols-2 sm:p-8" data-id="element-232" data-mp="12vfsnevi53ya">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-300/10 py-3 text-sm font-semibold text-slate-100" data-id="element-233" data-mp="3rkvudkim2lq8">
              <span className="silver-metal mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full" data-id="element-234" data-mp="3icechfmaiq4u">
                <CheckIcon className="h-3.5 w-3.5 text-blue-950" aria-hidden="true" data-id="element-235" data-mp="3naxz7i8pk5y9" />
              </span>
              {feature}
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-slate-300 bg-blue-950 px-6 py-5 text-center text-lg font-bold leading-relaxed text-white" data-id="element-236" data-mp="3ddjhzgeynd4w">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es hoy.”
        </blockquote>
      </div>
    </section>;
}